// extracted by mini-css-extract-plugin
export default {"__":"sideMenuButton_____k4Ft8","__active":"sideMenuButton___active__2hMUH"};